function jsonReplacer(_key, val) {
  if (val instanceof Error) {
    return {
      name: val.name,
      message: val.message,
      stack: val.stack,
    }
  }
  return val
}

/** String form for log message text (matches native console for Error). */
export function valueToLogString(value) {
  if (value === null) return 'null'
  if (value === undefined) return 'undefined'
  if (value instanceof Error) {
    return value.stack || `${value.name}: ${value.message}`
  }
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value, jsonReplacer, 2)
    } catch {
      return String(value)
    }
  }
  return String(value)
}

/** Clone-safe value for IndexedDB / postMessage (preserves error message + stack). */
export function serializeLogValue(value) {
  if (value instanceof Error) {
    return {
      name: value.name,
      message: value.message,
      stack: value.stack,
    }
  }
  if (value === null || value === undefined) return value
  if (typeof value !== 'object') return value
  try {
    return JSON.parse(JSON.stringify(value, jsonReplacer))
  } catch {
    return String(value)
  }
}

export default serializeLogValue
